export enum EMediaTabs {
  MEDIA_DOCUMENTS = 'media_documents',
  RESUME = 'resume',
  COMPOSITE_CARD = 'composite_card',
}
